import { mapState } from 'vuex';
import { cookieSignedInAsAdminUser } from 'Models/AdminModel';

const SignedAsInfo = () => import('Components/SignedAsInfo.vue');

const adminSignedAsUser = {

  data() {
    return {
      SignedAsInfoComponent: null,
    };
  },

  computed: {
    ...mapState(['adminSignedAsUser']),
  },

  created() {
    if (typeof window !== 'undefined') {
      const signedAsAdminId = this.$cookie.get(cookieSignedInAsAdminUser);
      if (signedAsAdminId) {
        this.$store.commit('mutateAdminSignedAsUser', true);
      }
    }
  },

  watch: {
    adminSignedAsUser(newValue) {
      if (newValue) {
        SignedAsInfo()
          .then((data) => {
            this.SignedAsInfoComponent = data.default;
          });
      } else {
        this.SignedAsInfoComponent = null;
      }
    },
  },
};

export default adminSignedAsUser;
